import { Action } from '@ngrx/store';

export enum NotificationActionTypes {
  GET_DATA_IN_WINDOW = '[NOTIFICATIONS] Get Notifications for window in header',
  GET_DATA_IN_WINDOW_SUCCESS = '[NOTIFICATIONS] Get Notifications for window in header Success',
  GET_DATA_IN_WINDOW_ERROR = '[NOTIFICATIONS] Get Notifications for window in header Error',

  GET_DATA_IN_CONTAINER = '[NOTIFICATIONS] Get Notifications for notifications page',
  GET_DATA_IN_CONTAINER_SUCCESS = '[NOTIFICATIONS] Get Notifications for container Success',
  GET_DATA_IN_CONTAINER_ERROR = '[NOTIFICATIONS] Get Notifications for container Error',

  CREATE = '[NOTIFICATIONS] Create Notification',
  CREATE_SUCCESS = '[NOTIFICATIONS] Create Notification Success',
  CREATE_ERROR = '[NOTIFICATIONS] Create Notification Error',

  READ_ALL = '[NOTIFICATIONS] ReadAll Notifications',
  READ_ALL_SUCCESS = '[NOTIFICATIONS] ReadAll Notifications Success',
  READ_ALL_ERROR = '[NOTIFICATIONS] ReadAll Notifications Error',

  READ_ONE_NOTIFICATION = '[NOTIFICATIONS] Read one Notification',
  READ_ONE_NOTIFICATION_SUCCESS = '[NOTIFICATIONS] Read one Notification Success',
  READ_ONE_NOTIFICATION_ERROR = '[NOTIFICATIONS] Read one Notification Error',
}

export class GetWindowNotifications implements Action {
  readonly type = NotificationActionTypes.GET_DATA_IN_WINDOW;
  constructor(public payload: any) {}
}
export class GetWindowNotificationsSuccess implements Action {
  readonly type = NotificationActionTypes.GET_DATA_IN_WINDOW_SUCCESS;
  constructor(public payload: any) {}
}
export class GetWindowNotificationsError implements Action {
  readonly type = NotificationActionTypes.GET_DATA_IN_WINDOW_ERROR;
  constructor(public payload: any) {}
}
export class GetContainerNotifications implements Action {
  readonly type = NotificationActionTypes.GET_DATA_IN_CONTAINER;
  constructor(public payload: any) {}
}
export class GetContainerNotificationsSuccess implements Action {
  readonly type = NotificationActionTypes.GET_DATA_IN_CONTAINER_SUCCESS;
  constructor(public payload: any) {}
}
export class GetContainerNotificationsError implements Action {
  readonly type = NotificationActionTypes.GET_DATA_IN_CONTAINER_ERROR;
  constructor(public payload: any) {}
}

export class CreateNotification implements Action {
  readonly type = NotificationActionTypes.CREATE;
  constructor(public payload: any) {}
}
export class CreateNotificationSuccess implements Action {
  readonly type = NotificationActionTypes.CREATE_SUCCESS;
  constructor(public payload: any) {}
}
export class CreateNotificationError implements Action {
  readonly type = NotificationActionTypes.CREATE_ERROR;
  constructor(public payload: any) {}
}

export class ReadAllNotifications implements Action {
  readonly type = NotificationActionTypes.READ_ALL;
  constructor(public payload: any) {}
}
export class ReadAllNotificationsSuccess implements Action {
  readonly type = NotificationActionTypes.READ_ALL_SUCCESS;
  constructor(public payload: any) {}
}
export class ReadAllNotificationsError implements Action {
  readonly type = NotificationActionTypes.READ_ALL_ERROR;
  constructor(public payload: any) {}
}

export class ReadOneNotification implements Action {
  readonly type = NotificationActionTypes.READ_ONE_NOTIFICATION;
  constructor(public payload: any) {}
}
export class ReadOneNotificationSuccess implements Action {
  readonly type = NotificationActionTypes.READ_ONE_NOTIFICATION_SUCCESS;
  constructor(public payload: any) {}
}
export class ReadOneNotificationError implements Action {
  readonly type = NotificationActionTypes.READ_ONE_NOTIFICATION_ERROR;
  constructor(public payload: any) {}
}

export type NotificationActions =
  | GetWindowNotifications
  | GetWindowNotificationsSuccess
  | GetWindowNotificationsError
  | GetContainerNotifications
  | GetContainerNotificationsSuccess
  | GetContainerNotificationsError
  | CreateNotification
  | CreateNotificationSuccess
  | CreateNotificationError
  | ReadAllNotifications
  | ReadAllNotificationsSuccess
  | ReadAllNotificationsError
  | ReadOneNotification
  | ReadOneNotificationSuccess
  | ReadOneNotificationError;
